var map = {
  "./Excel.svg": "80468",
  "./PDF@1x.svg": "77734",
  "./account.svg": "54104",
  "./address.svg": "67301",
  "./arrow-left-bold.svg": "70408",
  "./arrow-left.svg": "12680",
  "./arrow-up-bold.svg": "38984",
  "./avab_purchase.svg": "97987",
  "./bargain.svg": "30707",
  "./biz.svg": "46674",
  "./cart.svg": "13529",
  "./cartActive.svg": "1455",
  "./cartLogo.svg": "98348",
  "./chat-line-square.svg": "51828",
  "./chat.svg": "59013",
  "./collection-fill.svg": "16459",
  "./collection.svg": "88567",
  "./credit.svg": "24960",
  "./customer.svg": "25487",
  "./electronics.svg": "92264",
  "./email.svg": "14009",
  "./emoji.svg": "88731",
  "./exchange.svg": "84068",
  "./favarite.svg": "31277",
  "./finance.svg": "13267",
  "./forward.svg": "72946",
  "./global.svg": "3358",
  "./import.svg": "2160",
  "./invite.svg": "44836",
  "./jiucuo.svg": "59860",
  "./like.svg": "15494",
  "./logout.svg": "98973",
  "./mail.svg": "31134",
  "./member.svg": "56469",
  "./message.svg": "57299",
  "./motto.svg": "93822",
  "./no-pay.svg": "58447",
  "./notice.svg": "45791",
  "./noting.svg": "79374",
  "./order.svg": "81305",
  "./phone.svg": "80097",
  "./picture.svg": "66423",
  "./product.svg": "62712",
  "./q-zone.svg": "22247",
  "./qq.svg": "4825",
  "./qqicon.svg": "72710",
  "./question.svg": "19707",
  "./run.svg": "56562",
  "./share.svg": "45132",
  "./shipping.svg": "1285",
  "./shop.svg": "73007",
  "./sina.svg": "89072",
  "./state-false.svg": "42392",
  "./state-true.svg": "86175",
  "./tejia.svg": "92862",
  "./thumbs-up.svg": "78402",
  "./tip.svg": "85962",
  "./todo.svg": "44699",
  "./unfavarite.svg": "74856",
  "./unlike.svg": "91039",
  "./user.svg": "7730",
  "./users.svg": "68781",
  "./version.svg": "5521",
  "./wechar.svg": "25231",
  "./wechat.svg": "22561",
  "./weibo.svg": "81069",
  "./yangpian.svg": "16848",
  "./zheng.svg": "88147",
  "./zoom-in.svg": "50246",
  "./zoom-out.svg": "35745"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 28111;
